import { useEffect } from 'react';

import { useDebounce } from './useDebounce';

type UseWindowScrollOptions = {
    passive?: boolean;
    capture?: boolean;
};

export const useWindowScroll = (callback: () => void, delay: number = 100, options?: UseWindowScrollOptions) => {
    const debouncedCallback = useDebounce(callback, delay);

    useEffect(() => {
        window.addEventListener('scroll', debouncedCallback, options);

        return () => {
            window.removeEventListener('scroll', debouncedCallback, options);
        };
    }, [debouncedCallback, options]);
};
